export default "__VITE_ASSET__621ef69f__"